<div class="ic-card">
  <h2 class="ic-heading">NUMBER OF ISSUE AS PER CATEGORY</h2>
  <p class="ic-help">Broad Issue Category (L1) only - click to drill down - ⓘ Counts reflect Open and Closed issues only</p>
  <div class="ic-grid">
    <button type="button" class="ic-tile" *ngFor="let cat of categories"
      (click)="selectIssueCategory(cat.label)">
      <span class="ic-num">{{ cat.count }}</span>
      <span class="ic-lbl">{{ cat.label }}</span>
    </button>
  </div>
</div>
